import React, { useState, useContext, useEffect } from 'react';
import Axios from 'axios';
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap';
import { NavLink as RRNavLink, Link, useLocation } from 'react-router-dom';

import { ADMIN } from '../../../Data/Constants';
import { redirectToLoginPage } from '../../../Utils/AuthenticationHandler';
import { AuthContext } from '../../../Data/AuthContext';

import './NavigationBar.css';

function NavigationBar(props) {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();
    const auth = useContext(AuthContext);

    const { isAuthenticated, roles, name } = auth;

    const [pages, setPages] = useState([]);

    useEffect(() => {
        Axios.get(`/pages`).then(res => {
            setPages(res);
        });
    }, []);


    const loginNavItem = (
        <NavItem key="loginNavItem" className="px-lg-3">
            <NavLink tag={Link} to="" role="button" onClick={(e) => {
                e.preventDefault();
                redirectToLoginPage(location);
            }}>Bejelentkezés</NavLink>
        </NavItem>
    );

    const userNavItems = (
        <UncontrolledDropdown nav inNavbar className="px-lg-3">
            <DropdownToggle nav caret>
                {name}
            </DropdownToggle>
            <DropdownMenu end>
                <DropdownItem>
                    <NavLink tag={RRNavLink} to="/profile/">Profilom</NavLink>
                </DropdownItem>
                <DropdownItem>
                    <NavLink tag={Link} to="/" onClick={auth.logout}>Kijelentkezés</NavLink>
                </DropdownItem>
            </DropdownMenu>
        </UncontrolledDropdown>
    );

    const adminNavItem = (
        <NavItem className="px-lg-3">
            <NavLink tag={RRNavLink} to="/admin/">Adminisztráció</NavLink>
        </NavItem>
    );

    return (
        <Navbar dark expand="lg" className="py-lg-3">
            <NavbarBrand className="d-lg-none">VIK Szakestély</NavbarBrand>
            <NavbarToggler onClick={() => setIsOpen(!isOpen)} />
            <Collapse isOpen={isOpen} navbar>
                <Nav className="mx-auto" navbar>
                    <NavItem className="px-lg-3">
                        <NavLink tag={RRNavLink} to="/news/">Hírek</NavLink>
                    </NavItem>
                    <NavItem className="px-lg-3">
                        <NavLink tag={RRNavLink} to="/events/">Rendezvényeink</NavLink>
                    </NavItem>
                    {
                        pages.map(page => (
                            <NavItem className="px-lg-3">
                                <NavLink tag={RRNavLink} to={`/pages/${page.id}/${page.titleInUrl}`}>{page.title}</NavLink>
                            </NavItem>
                        ))
                    }
                    <NavItem className="px-lg-3">
                        <NavLink tag={RRNavLink} to="/members/">Tagjaink</NavLink>
                    </NavItem>
                    {roles && roles.includes(ADMIN) ? adminNavItem : null}
                    {isAuthenticated ? userNavItems : loginNavItem}
                </Nav>
            </Collapse>
        </Navbar>
    );
}


export default NavigationBar;
